import { ChevronRight, MoveDownRight, MoveUpRight } from 'lucide-react';
import { motion } from 'motion/react';
import Link from 'next/link';
import React from 'react';

import { routes } from '@/lib/routes';

export default function Hikes() {
  return (
    <>
      {/* Main Responsive Area */}
      <main
        className="overflow-y-none mx-auto flex w-full max-w-4xl flex-1 flex-col gap-6 px-4 py-2 pb-10"
        id="main_content"
      >
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.2 }}
          className="flex flex-col gap-6"
        >
          {/* Hikes List Section */}
          <div className="space-y-4">
            <div className="space-y-3">
              {routes.map((route) => {
                const distanceFormatted = `${route.distanceKm.toString().replace('.', ',')} km`;
                const cleanTitle = route.title.replace(/^\d+\.\s*den:\s*/i, '');

                return (
                  <Link
                    key={route.id}
                    href={`/route/${route.id}`}
                    className="group block overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-all hover:border-slate-300"
                  >
                    <div className="group relative flex h-64 w-full items-end justify-between overflow-hidden p-4 text-left sm:h-56">
                      {route.image ? (
                        <img
                          src={route.image}
                          alt={route.title}
                          className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                        />
                      ) : (
                        <div className="absolute inset-0 bg-slate-900" />
                      )}
                      {/* Gradient overlay */}
                      <div className="absolute inset-0 bg-linear-to-t from-slate-950/80 via-slate-950/30 to-transparent" />

                      {/* Bottom part: Title and Metrics */}
                      <div className="relative z-10 flex w-full flex-col text-white">
                        <span className="text-3xl leading-12 font-bold tracking-tight text-white drop-shadow-sm">
                          {route.day}. den
                        </span>
                        <h4 className="font-display mb-1 text-lg leading-snug font-bold text-white drop-shadow-md sm:text-xl">
                          {cleanTitle}
                        </h4>
                        <div className="flex items-center justify-between">
                          <div className="flex flex-col gap-0.5 text-xs font-medium text-slate-200 drop-shadow-sm sm:text-sm">
                            <div className="flex items-center gap-1.5">
                              <span>
                                Délka:{' '}
                                <strong className="font-semibold text-white">
                                  {distanceFormatted}
                                </strong>
                              </span>
                              <span>&bull;</span>
                              <span>
                                Čas:{' '}
                                <strong className="font-semibold text-white">
                                  {route.estimatedTime}
                                </strong>
                              </span>
                            </div>
                            <div className="flex items-center gap-1.5">
                              <span>Výškový profil:</span>
                              <span className="inline-flex items-center gap-0.5">
                                <MoveUpRight
                                  strokeWidth="3"
                                  className="h-3.5 w-3.5 text-emerald-500"
                                />
                                <strong className="font-semibold text-white">
                                  {route.elevationGainM} m
                                </strong>
                              </span>
                              <span className="inline-flex items-center gap-0.5">
                                <MoveDownRight
                                  strokeWidth="3"
                                  className="h-3.5 w-3.5 text-emerald-500"
                                />
                                <strong className="font-semibold text-white">
                                  {route.elevationLossM} m
                                </strong>
                              </span>
                            </div>
                          </div>

                          <div className="ml-4 shrink-0 text-white/80 transition-transform duration-200 group-hover:translate-x-0.5">
                            <ChevronRight className="h-6 w-6" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </motion.div>
      </main>
    </>
  );
}
